import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { CreateConfirmation } from '../../model/confirmation.model';
import { OverlayContainer } from '@angular/cdk/overlay';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrl: './confirmation-dialog.component.scss',
    standalone: false
})
export class ConfirmationDialogComponent {
  showTitle?: boolean = false;
  title?: string = "";
  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    private overlayContainer: OverlayContainer,
    @Inject(MAT_DIALOG_DATA) public data: CreateConfirmation) {
    this.showTitle = this.data?.showTitle;
    this.title = this.data?.title;
    this.data.okOnly = !!this.data.okOnly;
  }

  closeAllOverlays(): void {
    const container = this.overlayContainer.getContainerElement();
    // Remove all overlay content
    container.innerHTML = '';
  }

}

